<template>
  <div>
    <validation-observer ref="form">
      <form novalidate @submit.prevent="saveWoundCourse">
        <mdb-modal position="right" side fullHeight size="lg" direction="right" :show="modal" @close="close">
            <mdb-modal-header>
                <mdb-modal-title class="h4">
                  Wunderhebung erstellen
                </mdb-modal-title>
            </mdb-modal-header>
            <mdb-modal-body class="flex-wrap example-card scrollbar-blue thin">
              <mdb-stepper
                v-model="currentStep"
                :steps="5"
                :options="stepsConfig"
                within
                validation
                :validatedSteps="validatedSteps"
              >
                <template #1>
                  <validation-provider
                    name="Datum der Wunderhebung"
                    rules="required"
                    v-slot="{ errors, valid, validated }"
                    slim
                  >
                    <mdb-date-picker
                      class="pt-4"
                      v-model="wunderhebung"
                      disabledFuture
                      label="Datum der Wunderhebung"
                      name="Datum der Wunderhebung"
                      :option="optionDatePicker"
                      :customValidation="validated"
                      :isValid="valid"
                      :invalidFeedback="errors[0]"
                      validFeedback="sieht gut aus"
                      outline
                      @getValue="getPickersValue"
                    />
                  </validation-provider>
                  <validation-provider
                    name="Enstehungszeitpunkt"
                    rules=""
                    v-slot="{ errors, valid, validated }"
                    slim
                  >
                    <mdb-date-picker
                      v-model="enstehungszeitpunkt"
                      disabledFuture
                      label="Enstehungszeitpunkt"
                      name="Enstehungszeitpunkt"
                      :option="optionDatePicker"
                      :customValidation="validated"
                      :isValid="valid"
                      :invalidFeedback="errors[0]"
                      validFeedback="sieht gut aus"
                      outline
                      @getValue="getPickersZeitValue"
                    />
                  </validation-provider>
                  <validation-provider
                    name="Heilungszeitpunkt"
                    v-slot="{ errors, valid, validated }"
                    slim
                  >
                    <mdb-date-picker
                      v-model="heilungszeitpunkt"
                      disabledFuture
                      label="Heilungszeitpunkt"
                      name="Heilungszeitpunkt"
                      :option="optionDatePicker"
                      :customValidation="validated"
                      :isValid="valid"
                      :invalidFeedback="errors[0]"
                      validFeedback="sieht gut aus"
                      outline
                      @getValue="getPickersHeilungValue"
                    />
                  </validation-provider>
                  <validation-provider
                    name="Ort der Wunde"
                    rules="required|max:30"
                    v-slot="{ errors, valid, validated }"
                    slim
                  >
                    <mdb-input
                      id="ort"
                      ref="ort"
                      v-model="form.Ort"
                      type="text"
                      label="Ort der Wunde"
                      outline
                      validation
                      required
                    />
                  </validation-provider>
                  <span class="h5 ml-2">Wundart/Stadien</span>
                  <mdb-row class="mt-2">
                    <mdb-col col="6">
                      <mdb-input type="checkbox" id="checkbox1" v-model="form.Wundart_SekWundheilung" class="mb-0 my-2" label="sekundäre Wundheilung" />
                      <mdb-input type="checkbox" id="checkbox2" v-model="form.Wundart_ChrArtUlcus" class="mb-0 my-2" label="chronisch arterielles Ulcus" />
                      <mdb-input type="checkbox" id="checkbox3" v-model="form.Wundart_Pilz" class="mb-0 my-2" label="Pilz/Exanthem"/>
                      <mdb-input type="checkbox" id="checkbox4" v-model="form.Wundart_Dekubitus2" class="mb-0 my-2" label="Dekubitus II.Grad"/>
                      <mdb-input type="checkbox" id="checkbox5" v-model="form.Wundart_Dekubitus4" class="mb-0 my-2" label="Dekubitus IV.Grad"/>
                    </mdb-col>
                    <mdb-col col="6">
                      <mdb-input type="checkbox" id="checkbox6" v-model="form.Wundart_ChrVenUlcus" class="mb-0 my-2" label="chronisch venöses Ulcus" />
                      <mdb-input type="checkbox" id="checkbox7" v-model="form.Wundart_ExuWunde" class="mb-0 my-2" label="exulcerierende Wunde" />
                      <mdb-input type="checkbox" id="checkbox8" v-model="form.Wundart_Dekubitus1" class="mb-0 my-2" label="Dekubitus I.Grad"/>
                      <mdb-input type="checkbox" id="checkbox9" v-model="form.Wundart_Dekubitus3" class="mb-0 my-2" label="Dekubitus III.Grad"/>
                      <mdb-input type="checkbox" id="checkbox10" v-model="form.Wundart_Intertrigo" class="mb-0 my-2" label="Intertrigo"/>
                    </mdb-col>
                  </mdb-row>
                  <validation-provider
                    name="Freitext"
                    v-slot="{ errors, valid, validated }"
                    slim
                  >
                    <mdb-input
                      v-model="form.Wundart_Freitext"
                      type="textarea"
                      :rows="5"
                      label="Freitext"
                      name="Freitext"
                      :customValidation="validated"
                      :isValid="valid"
                      :invalidFeedback="errors[0]"
                      validFeedback="sieht gut aus"
                      outline
                    />
                  </validation-provider>
                </template>
                <template #2>
                  <mdb-row class="pt-4">
                    <mdb-col col="12">
                      <span class="h5 ml-2">Gradeinteilung</span>
                      <mdb-form-inline class="my-3 ml-3">
                        <mdb-input type="checkbox" v-model="form.Gradeinteilung_G1" id="G1" class="mb-2" label="G1" />
                        <mdb-input type="checkbox" v-model="form.Gradeinteilung_G2" id="G2" class="mb-2" label="G2" />
                        <mdb-input type="checkbox" v-model="form.Gradeinteilung_G3" id="G3" class="mb-2" label="G3" />
                        <mdb-input type="checkbox" v-model="form.Gradeinteilung_G4" id="G4" class="mb-2" label="G4" />
                      </mdb-form-inline>
                    </mdb-col>
                  </mdb-row>
                  <mdb-row class="my-3">
                    <mdb-col col="12">
                      <span class="h5 ml-2">Wundheilungsphase</span>
                      <mdb-form-inline class="my-3 ml-3">
                        <mdb-input type="checkbox" v-model="form.Wundheilung_W1" id="W1" class="mb-2" label="W1" />
                        <mdb-input type="checkbox" v-model="form.Wundheilung_W2" id="W2" class="mb-2" label="W2" />
                        <mdb-input type="checkbox" v-model="form.Wundheilung_W3" id="W3" class="mb-2" label="W3" />
                        <mdb-input type="checkbox" v-model="form.Wundheilung_W4" id="W4" class="mb-2" label="W4" />
                      </mdb-form-inline>
                    </mdb-col>
                  </mdb-row>
                  <span class="h5 ml-2">Wundgrund</span>
                  <mdb-row class="mt-3">
                    <mdb-col xs="12" sm="6" md="6" lg="4">
                      <mdb-input type="checkbox" v-model="form.Wundgrund_Granulation" class="mb-2" id="Granulation" label="Granulation" />
                    </mdb-col>
                    <mdb-col xs="12" sm="6" md="6" lg="4">
                      <mdb-input type="checkbox" v-model="form.Wundgrund_Muskel" class="mb-2" id="Muskel" label="Muskel" />
                    </mdb-col>
                    <mdb-col xs="12" sm="6" md="6" lg="4">
                      <mdb-input type="checkbox" v-model="form.Wundgrund_Knochen" class="mb-2" id="Knochen" label="Knochen" />
                    </mdb-col>
                    <mdb-col xs="12" sm="6" md="6" lg="4">
                      <mdb-input type="checkbox" v-model="form.Wundgrund_Nekrose" class="mb-2" id="Nekrose" label="Nekrose" />
                    </mdb-col>
                    <mdb-col xs="12" sm="6" md="6" lg="4">
                      <mdb-input type="checkbox" class="mb-2" v-model="form.Wundgrund_Fibrin" id="Fibrin" label="Fibrin" />
                    </mdb-col>
                  </mdb-row>
                  <mdb-row class="mt-4">
                    <mdb-col col="12">
                      <span class="h5 ml-2">Wundsekretion</span>
                      <mdb-form-inline class="my-3 ml-3">
                        <mdb-input type="checkbox" v-model="form.Wundsekretion_Keine" id="keine" class="mb-2" label="keine" />
                        <mdb-input type="checkbox" v-model="form.Wundsekretion_Maessig" id="mäßig" class="mb-2" label="mäßig" />
                        <mdb-input type="checkbox" v-model="form.Wundsekretion_Wenig" id="wenig" class="mb-2" label="wenig" />
                        <mdb-input type="checkbox" v-model="form.Wundsekretion_Viel" id="viel" class="mb-2" label="viel" />
                      </mdb-form-inline>
                    </mdb-col>
                  </mdb-row>
                  <mdb-row class="my-3">
                    <mdb-col col="12">
                      <span class="h5 ml-2">Sekretfarbe</span>
                      <mdb-form-inline class="my-3 ml-3">
                        <mdb-input type="checkbox" v-model="form.Sektionsfarbe_Gelblich" id="gelblich/serös" class="mb-2" label="gelblich/serös" />
                        <mdb-input type="checkbox" v-model="form.Sektionsfarbe_Gruenlich" id="grünlich" class="mb-2" label="grünlich" />
                        <mdb-input type="checkbox" v-model="form.Sektionsfarbe_Eitrig" id="eitrig/rahmig" class="mb-2" label="eitrig/rahmig" />
                        <mdb-input type="checkbox" v-model="form.Sektionsfarbe_Blutig" id="blutig/serös" class="mb-2" label="blutig/serös" />
                      </mdb-form-inline>
                    </mdb-col>
                  </mdb-row>
                  <span class="h5 ml-2">Geruch</span>
                  <mdb-row class="mt-3 mb-4">
                    <mdb-col xs="12" sm="6" md="6" lg="4">
                      <mdb-input type="checkbox" v-model="form.Geruch_Blutig" id="blutig" class="mb-2" label="blutig" />
                    </mdb-col>
                    <mdb-col xs="12" sm="6" md="6" lg="4">
                      <mdb-input type="checkbox" v-model="form.Geruch_Unauffaellig" id="unauffällig" class="mb-2" label="unauffällig" />
                    </mdb-col>
                    <mdb-col xs="12" sm="6" md="6" lg="4">
                      <mdb-input type="checkbox" v-model="form.Geruch_Faekulent" id="fäkulent" class="mb-2" label="fäkulent" />
                    </mdb-col>
                    <mdb-col xs="12" sm="6" md="6" lg="4">
                      <mdb-input type="checkbox" v-model="form.Geruch_Suesslich" id="süsslich" class="mb-2" label="süsslich" />
                    </mdb-col>
                    <mdb-col xs="12" sm="6" md="6" lg="4">
                      <mdb-input type="checkbox" v-model="form.Geruch_Faulig" id="faulig/jauchig" class="mb-2" label="faulig/jauchig" />
                    </mdb-col>
                  </mdb-row>
                  <span class="h5 ml-2 ">Wundränder</span>
                  <mdb-row class="mt-2">
                    <mdb-col xs="12" sm="6" md="6" lg="4">
                      <mdb-input type="checkbox" v-model="form.Wundraender_Unaufaellig" id="unaufällig" class="mb-0 my-2" label="unaufällig" />
                    </mdb-col>
                    <mdb-col xs="12" sm="6" md="6" lg="4">
                      <mdb-input type="checkbox" v-model="form.Wundraender_Mazeriert" id="mazeriert" class="mb-0 my-2" label="mazeriert" />
                    </mdb-col>
                    <mdb-col xs="12" sm="6" md="6" lg="4">
                      <mdb-input type="checkbox" v-model="form.Wundraender_Gerollt" id="gerollt/wulstig" class="mb-0 my-2" label="gerollt/wulstig"/>
                    </mdb-col>
                    <mdb-col xs="12" sm="6" md="6" lg="4">
                      <mdb-input type="checkbox" v-model="form.Wundraender_Nekrotisch" id="nekrotisch" class="mb-0 my-2" label="nekrotisch"/>
                    </mdb-col>
                    <mdb-col xs="12" sm="6" md="6" lg="4">
                      <mdb-input type="checkbox" v-model="form.Wundraender_Entzuendet" id="entzündet" class="mb-0 my-2" label="entzündet"/>
                    </mdb-col>
                    <mdb-col xs="12" sm="6" md="6" lg="4">
                      <mdb-input type="checkbox" v-model="form.Wundraender_Oedematoes" id="ödematoes" class="mb-0 my-2" label="ödematoes" />
                    </mdb-col>
                    <mdb-col xs="12" sm="6" md="6" lg="4">
                      <mdb-input type="checkbox" v-model="form.Wundraender_Abgegrenzt" id="gut abgegrenzt" class="mb-0 my-2" label="gut abgegrenzt" />
                    </mdb-col>
                    <mdb-col xs="12" sm="6" md="6" lg="4">
                      <mdb-input type="checkbox" v-model="form.Wundraender_Rosig" id="rosig" class="mb-0 my-2" label="rosig"/>
                    </mdb-col>
                    <mdb-col xs="12" sm="6" md="6" lg="4">
                      <mdb-input type="checkbox" v-model="form.Wundraender_Unterminiert" id="unterminiert" class="mb-0 my-2" label="unterminiert"/>
                    </mdb-col>
                  </mdb-row>
                  <validation-provider
                    name="sonstiges..."
                    rules="max:30"
                    v-slot="{ errors, valid, validated }"
                    slim
                  >
                    <mdb-input
                      v-model="form.Wundraender_Sonstige"
                      type="text"
                      label="sonstiges..."
                      name="sonstiges..."
                      :customValidation="validated"
                      :isValid="valid"
                      :invalidFeedback="errors[0]"
                      validFeedback="sieht gut aus"
                      outline
                    />
                  </validation-provider>
                </template>
                <template #3>
                  <mdb-switch
                    v-model="form.Schmerzen"
                    color="primary"
                    class="mb-4 pt-4"
                    offLabel=""
                    onLabel="Schmerzen"
                  />
                  <mdb-switch
                    v-model="form.Bekaempfung"
                    color="primary"
                    class="mb-4"
                    offLabel=""
                    onLabel="Schmerzbekämpfung"
                  />
                  <validation-provider
                    name="Medikament/Dosierung"
                    rules="max:100"
                    v-slot="{ errors, valid, validated }"
                    slim
                  >
                    <mdb-input
                      v-model="form.Bekaempfung_Text"
                      type="text"
                      label="Medikament/Dosierung"
                      name="Medikament/Dosierung"
                      :customValidation="validated"
                      :isValid="valid"
                      :invalidFeedback="errors[0]"
                      validFeedback="sieht gut aus"
                      outline
                    />
                  </validation-provider>
                  <validation-provider
                    name="Länge der Wunde in cm"
                    rules="max:10"
                    v-slot="{ errors, valid, validated }"
                    slim
                  >
                    <mdb-input
                      v-model="form.Groesse_Laenge"
                      type="text"
                      label="Länge der Wunde in cm"
                      name="Länge der Wunde in cm"
                      :customValidation="validated"
                      :isValid="valid"
                      :invalidFeedback="errors[0]"
                      validFeedback="sieht gut aus"
                      outline
                    />
                  </validation-provider>
                  <validation-provider
                    name="Breite der Wunde in cm"
                    rules="max:10"
                    v-slot="{ errors, valid, validated }"
                    slim
                  >
                    <mdb-input
                      v-model="form.Groesse_Breite"
                      type="text"
                      label="Breite der Wunde in cm"
                      name="Breite der Wunde in cm"
                      :customValidation="validated"
                      :isValid="valid"
                      :invalidFeedback="errors[0]"
                      validFeedback="sieht gut aus"
                      outline
                    />
                  </validation-provider>
                  <validation-provider
                    name="Tiefe der Wunde in cm"
                    rules="max:10"
                    v-slot="{ errors, valid, validated }"
                    slim
                  >
                    <mdb-input
                      v-model="form.Groesse_Tiefe"
                      type="text"
                      label="Tiefe der Wunde in cm"
                      name="Tiefe der Wunde in cm"
                      :customValidation="validated"
                      :isValid="valid"
                      :invalidFeedback="errors[0]"
                      validFeedback="sieht gut aus"
                      outline
                    />
                  </validation-provider>
                  <mdb-switch
                    v-model="form.Taschenbildung"
                    color="primary"
                    class="mb-4"
                    offLabel=""
                    onLabel="Taschenbildung"
                  />

                  <validation-provider
                    name="Uhrzeit"
                    rules="max:10"
                    v-slot="{ errors, valid, invalid }"
                    slim
                  >
                    <mdb-time-picker
                      v-if="form.Taschenbildung"
                      id="uhrzeit"
                      v-model="form.Taschenbildung_Uhrzeit"
                      label="Uhrzeit"
                      name="Uhrzeit"
                      :hours-format="24"
                      class="mb-0"
                      outline
                      :done-label="optionTimePicker.done"
                      :closeLabel="optionTimePicker.cancel"
                      :clearLabel="optionTimePicker.clear"
                      @getValue="verifyValue"
                    />
                    <span v-if="valid" class="valid-feedback d-block">sieht gut aus</span>
                    <span v-if="invalid" class="invalid-feedback d-block">{{ errors[0] }}</span>
                  </validation-provider>
                  <validation-provider
                    name="Tiefe Tasche"
                    rules="max:10"
                    v-slot="{ errors, valid, validated }"
                    slim
                  >
                    <mdb-input
                      v-if="form.Taschenbildung"
                      v-model="form.Taschenbildung_Tiefe"
                      type="text"
                      :maxlength="10"
                      label="Tiefe Tasche"
                      name="Tiefe Tasche"
                      :customValidation="validated"
                      :isValid="valid"
                      :invalidFeedback="errors[0]"
                      validFeedback="sieht gut aus"
                      outline
                    />
                  </validation-provider>
                </template>
                <template #4>
                  <div class="pt-4">
                    <span class="h5 ml-2">Maßnahmen zur Wundreinigung</span>
                  </div>
                  <mdb-row class="my-3">
                    <mdb-col xs="12" sm="6" md="6" lg="3">
                        <mdb-input type="checkbox" v-model="form.Wundreinigung_NaCi" id="NaCl" label="NaCl" />
                    </mdb-col>
                    <mdb-col xs="12" sm="6" md="6" lg="3">
                        <mdb-input type="checkbox" v-model="form.Wundreinigung_Ringerloesung" id="Ringerlösung" label="Ringerlösung" />
                    </mdb-col>
                    <mdb-col xs="12" sm="6" md="6" lg="3">
                        <mdb-input type="checkbox" v-model="form.Wundreinigung_Prontosan" id="Prontosan" label="Prontosan" />
                    </mdb-col>
                    <mdb-col xs="12" sm="6" md="6" lg="3">
                        <mdb-input type="checkbox" v-model="form.Wundreinigung_Octenisept" id="Octenisept" label="Octenisept" />
                    </mdb-col>
                  </mdb-row>
                  <validation-provider
                    name="Verbandablauf/Verbandart"
                    v-slot="{ errors, valid, validated }"
                    slim
                  >
                    <mdb-input
                      v-model="form.Verbandablauf_Text"
                      type="text"
                      label="Verbandablauf/Verbandart"
                      name="Verbandablauf/Verbandart"
                      :customValidation="validated"
                      :isValid="valid"
                      :invalidFeedback="errors[0]"
                      validFeedback="sieht gut aus"
                      outline
                    />
                  </validation-provider>
                  <validation-provider
                    name="Salben"
                    rules="max:100"
                    v-slot="{ errors, valid, validated }"
                    slim
                  >
                    <mdb-input
                      v-model="form.Salben"
                      type="text"
                      label="Salben"
                      name="Salben"
                      :customValidation="validated"
                      :isValid="valid"
                      :invalidFeedback="errors[0]"
                      validFeedback="sieht gut aus"
                      outline
                    />
                  </validation-provider>
                  <validation-provider
                    name="Wechselintervall"
                    v-slot="{ errors, valid, validated }"
                    slim
                  >
                    <mdb-input
                      v-model="form.Wechselintervall"
                      type="text"
                      label="Wechselintervall"
                      name="Wechselintervall"
                      :customValidation="validated"
                      :isValid="valid"
                      :invalidFeedback="errors[0]"
                      validFeedback="sieht gut aus"
                      outline
                    />
                  </validation-provider>
                  <validation-provider
                    name="Versorgung von Wundrand und Wundumgebung"
                    rules="max:100"
                    v-slot="{ errors, valid, validated }"
                    slim
                  >
                    <mdb-input
                      v-model="form.Versorgung_Wundrand"
                      type="text"
                      label="Versorgung von Wundrand und Wundumgebung"
                      name="Versorgung von Wundrand und Wundumgebung"
                      :customValidation="validated"
                      :isValid="valid"
                      :invalidFeedback="errors[0]"
                      validFeedback="sieht gut aus"
                      outline
                    />
                  </validation-provider>
                </template>
                <template #5>
                  <div class="pt-4">
                    <span class="h5 ml-2">Kausaltherapie</span>
                  </div>
                  <mdb-row class="my-3">
                    <mdb-col xs="12" sm="6" md="6" lg="6">
                      <mdb-input type="checkbox" v-model="form.Kausaltherapie_Weichlagerung" id="Weichlagerungssystem" class="mb-2" label="Weichlagerungssystem" />
                    </mdb-col>
                    <mdb-col xs="12" sm="6" md="6" lg="6">
                        <mdb-input type="checkbox" v-model="form.Kausaltherapie_Wechseldruck" id="Wechseldrucksystem" class="mb-2" label="Wechseldrucksystem" />
                    </mdb-col>
                    <mdb-col xs="12" sm="6" md="6" lg="6">
                        <mdb-input type="checkbox" v-model="form.Kausaltherapie_Micro" id="Micro-Stimulations-System" class="mb-2" label="Micro-Stimulations-System" />
                    </mdb-col>
                    <mdb-col xs="12" sm="6" md="6" lg="6">
                        <mdb-input type="checkbox" v-model="form.Kausaltherapie_Lagerungskissen" id="Lagerungskissen/Keile" class="mb-2" label="Lagerungskissen/Keile" />
                    </mdb-col>
                  </mdb-row>
                  <validation-provider
                    name="sonstige..."
                    rules="max:30"
                    v-slot="{ errors, valid, validated }"
                    slim
                  >
                    <mdb-input
                      v-model="form.Kausaltherapie_Sonstige"
                      type="text"
                      label="sonstige..."
                      name="sonstige..."
                      :customValidation="validated"
                      :isValid="valid"
                      :invalidFeedback="errors[0]"
                      validFeedback="sieht gut aus"
                      outline
                    />
                  </validation-provider>
                  <validation-provider
                    name="Einsatzseit"
                    rules=""
                    v-slot="{ errors, valid, validated }"
                    slim
                  >
                    <mdb-date-picker
                      v-model="kausaltherapie_Seit"
                      disabledFuture
                      label="Einsatzseit"
                      name="Einsatzseit"
                      :option="optionDatePicker"
                      :customValidation="validated"
                      :isValid="valid"
                      :invalidFeedback="errors[0]"
                      validFeedback="sieht gut aus"
                      outline
                      @getValue="getPickersSeitValue"
                    />
                  </validation-provider>
                  <validation-provider
                    name="Lagerungsintervall (stündlich)"
                    v-slot="{ errors, valid, validated }"
                    slim
                  >
                    <mdb-input
                      v-model="form.Kausaltherapie_Intervall"
                      type="text"
                      label="Lagerungsintervall (stündlich)"
                      name="Lagerungsintervall (stündlich)"
                      :customValidation="validated"
                      :isValid="valid"
                      :invalidFeedback="errors[0]"
                      validFeedback="sieht gut aus"
                      outline
                    />
                  </validation-provider>
                </template>
              </mdb-stepper>
            </mdb-modal-body>
            <mdb-modal-footer>
              <mdb-btn
                v-if="currentStep==1"
                color="grey lighten-1"
                @click.native="close"
              >
                Zurück
              </mdb-btn>
              <mdb-btn
                v-else
                color="grey lighten-1"
                @click.native="backStep"
              >
                Zurück
              </mdb-btn>

              <mdb-btn
                v-if="currentStep < 5"
                color="primary"
                @click.native="stepChange"
              >
                Weiter <mdb-icon icon="angle-right" />
              </mdb-btn>
              <mdb-btn
                v-else
                color="primary"
                :disabled="loading"
                type="submit"
              >
                <template v-if="!loading">
                  Erstellen <mdb-icon icon="save" />
                </template>
                <template v-else>
                  <span
                    class="spinner-grow spinner-grow-sm"
                    role="status"
                    aria-hidden="true"
                  />
                  Verladung
                </template>
              </mdb-btn>
            </mdb-modal-footer>
        </mdb-modal>
      </form>
    </validation-observer>
  </div>
</template>

<script>
  import {
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbBtn,
    mdbDatePicker,
    mdbInput,
    mdbSwitch,
    mdbStepper,
    mdbRow,
    mdbCol,
    mdbFormInline,
    mdbTimePicker,
    mdbIcon
  } from 'mdbvue';
  import utils from '@/mixins/Utils'

  export default {
    name: 'AddMiracleElevation',
    mixins: [utils()],

    components: {
      mdbModal,
      mdbModalHeader,
      mdbModalTitle,
      mdbModalBody,
      mdbModalFooter,
      mdbBtn,
      mdbDatePicker,
      mdbInput,
      mdbSwitch,
      mdbStepper,
      mdbRow,
      mdbCol,
      mdbFormInline,
      mdbTimePicker,
      mdbIcon
    },

    props: {
      modalState: {
        type: Boolean,
        default: false,
      },
    },

    data() {
      return {
        modal: false,
        currentStep: 1,
        isDeepPocket: false,
        loading: false,
        uhrzeit: new Date().getHours() + ":" + new Date().getMinutes(),
        datum: new Date().toISOString().slice(0,10),
        wunderhebung: new Date().toJSON().slice(0,10).split('-').reverse().join('-'),
        enstehungszeitpunkt: new Date().toJSON().slice(0,10).split('-').reverse().join('-'),
        heilungszeitpunkt: '',
        kausaltherapie_Seit: '',
        form: {
          GastId: null,
          Wunderhebung: '',
          Enstehungszeitpunkt: '',
          Heilungszeitpunkt: null,
          Ort: '',
          Wundart_SekWundheilung: false,
          Wundart_ChrVenUlcus: false,
          Wundart_ChrArtUlcus: false,
          Wundart_ExuWunde: false,
          Wundart_Pilz: false,
          Wundart_Dekubitus1: false,
          Wundart_Dekubitus2: false,
          Wundart_Dekubitus3: false,
          Wundart_Dekubitus4: false,
          Wundart_Intertrigo: false,
          Wundart_Freitext: '',
          Gradeinteilung_G1: false,
          Gradeinteilung_G2: false,
          Gradeinteilung_G3: false,
          Gradeinteilung_G4: false,
          Wundheilung_W1: false,
          Wundheilung_W2: false,
          Wundheilung_W3: false,
          Wundheilung_W4: false,
          Wundgrund_Granulation: false,
          Wundgrund_Muskel: false,
          Wundgrund_Knochen: false,
          Wundgrund_Nekrose: false,
          Wundgrund_Fibrin: false,
          Wundsekretion_Keine: false,
          Wundsekretion_Maessig: false,
          Wundsekretion_Wenig: false,
          Wundsekretion_Viel: false,
          Sektionsfarbe_Gelblich: false,
          Sektionsfarbe_Gruenlich: false,
          Sektionsfarbe_Eitrig: false,
          Sektionsfarbe_Blutig: false,
          Geruch_Blutig: false,
          Geruch_Unauffaellig: false,
          Geruch_Faekulent: false,
          Geruch_Suesslich: false,
          Geruch_Faulig: false,
          Wundraender_Unaufaellig: false,
          Wundraender_Mazeriert: false,
          Wundraender_Gerollt: false,
          Wundraender_Nekrotisch: false,
          Wundraender_Entzuendet: false,
          Wundraender_Oedematoes: false,
          Wundraender_Abgegrenzt: false,
          Wundraender_Rosig: false,
          Wundraender_Unterminiert: false,
          Schmerzen: false,
          Bekaempfung: false,
          Bekaempfung_Text: '',
          Groesse_Laenge: '',
          Groesse_Breite: '',
          Groesse_Tiefe: '',
          Taschenbildung: false,
          Taschenbildung_Uhrzeit: '',
          Taschenbildung_Tiefe: '',
          Wundreinigung_NaCi: false,
          Wundreinigung_Ringerloesung: false,
          Wundreinigung_Prontosan: false,
          Wundreinigung_Octenisept: false,
          Verbandablauf_Text: '',
          Salben: '',
          Wechselintervall: '',
          Versorgung_Wundrand: '',
          Kausaltherapie_Weichlagerung: false,
          Kausaltherapie_Wechseldruck: false,
          Kausaltherapie_Micro: false,
          Kausaltherapie_Lagerungskissen: false,
          Kausaltherapie_Sonstige: '',
          Kausaltherapie_Seit: '',
          Kausaltherapie_Intervall: '',
        },
        defaultForm: {
          GastId: null,
          Wunderhebung: '',
          Enstehungszeitpunkt: '',
          Heilungszeitpunkt: '',
          Ort: '',
          Wundart_SekWundheilung: false,
          Wundart_ChrVenUlcus: false,
          Wundart_ChrArtUlcus: false,
          Wundart_ExuWunde: false,
          Wundart_Pilz: false,
          Wundart_Dekubitus1: false,
          Wundart_Dekubitus2: false,
          Wundart_Dekubitus3: false,
          Wundart_Dekubitus4: false,
          Wundart_Intertrigo: false,
          Wundart_Freitext: '',
          Gradeinteilung_G1: false,
          Gradeinteilung_G2: false,
          Gradeinteilung_G3: false,
          Gradeinteilung_G4: false,
          Wundheilung_W1: false,
          Wundheilung_W2: false,
          Wundheilung_W3: false,
          Wundheilung_W4: false,
          Wundgrund_Granulation: false,
          Wundgrund_Muskel: false,
          Wundgrund_Knochen: false,
          Wundgrund_Nekrose: false,
          Wundgrund_Fibrin: false,
          Wundsekretion_Keine: false,
          Wundsekretion_Maessig: false,
          Wundsekretion_Wenig: false,
          Wundsekretion_Viel: false,
          Sektionsfarbe_Gelblich: false,
          Sektionsfarbe_Gruenlich: false,
          Sektionsfarbe_Eitrig: false,
          Sektionsfarbe_Blutig: false,
          Geruch_Blutig: false,
          Geruch_Unauffaellig: false,
          Geruch_Faekulent: false,
          Geruch_Suesslich: false,
          Geruch_Faulig: false,
          Wundraender_Unaufaellig: false,
          Wundraender_Mazeriert: false,
          Wundraender_Gerollt: false,
          Wundraender_Nekrotisch: false,
          Wundraender_Entzuendet: false,
          Wundraender_Oedematoes: false,
          Wundraender_Abgegrenzt: false,
          Wundraender_Rosig: false,
          Wundraender_Unterminiert: false,
          Schmerzen: false,
          Bekaempfung: false,
          Bekaempfung_Text: '',
          Groesse_Laenge: '',
          Groesse_Breite: '',
          Groesse_Tiefe: '',
          Taschenbildung: false,
          Taschenbildung_Uhrzeit: '',
          Taschenbildung_Tiefe: '',
          Wundreinigung_NaCi: false,
          Wundreinigung_Ringerloesung: false,
          Wundreinigung_Prontosan: false,
          Wundreinigung_Octenisept: false,
          Verbandablauf_Text: '',
          Salben: '',
          Wechselintervall: '',
          Versorgung_Wundrand: '',
          Kausaltherapie_Weichlagerung: false,
          Kausaltherapie_Wechseldruck: false,
          Kausaltherapie_Micro: false,
          Kausaltherapie_Lagerungskissen: false,
          Kausaltherapie_Sonstige: '',
          Kausaltherapie_Seit: '',
          Kausaltherapie_Intervall: '',
        },
        stepsConfig: {
            withinBtn: {
              active: "blue",
              color: "grey darken-2",
          }
        },
        validatedSteps: {}
      }
    },

    watch: {
      modalState (v) {
        this.modal = v
      },
    },

    methods: {
      close () {
        this.currentStep = 1
        this.$refs.form.reset()
        this.datum = new Date().toISOString().slice(0,10),
        this.uhrzeit = new Date().getHours() + ":" + new Date().getMinutes(),

        this.wunderhebung = new Date().toJSON().slice(0,10).split('-').reverse().join('-'),
        this.enstehungszeitpunkt = new Date().toJSON().slice(0,10).split('-').reverse().join('-'),
        this.form = Object.assign({}, this.defaultForm)
        this.$emit('close')
      },

      save ()
      {
        this.close()
        this.$emit('save')
      },

      getPickersValue (value) {
        if(value) {
          this.wunderhebung = value
        }
      },

      getPickersZeitValue (value) {
        if(value) {
          this.enstehungszeitpunkt = value
        }
      },

      getPickersHeilungValue (value) {
        if(value) {
          this.heilungszeitpunkt = value
        }
      },

      getPickersSeitValue (value) {
        if(value) {
          this.kausaltherapie_Seit = value
        }
      },

      getSwitchValue () {
        this.form.Taschenbildung = !this.form.Taschenbildung
      },

      stepChange () {
        this.validate(this.currentStep)
      },

      backStep () {
        this.currentStep === 6 ? this.currentStep -= 2 : this.currentStep -= 1
      },

      verifyValue() {
        const time = document.getElementById('uhrzeit')
        if(time) {
          if(this.uhrzeit === '' || this.uhrzeit === undefined) {
            time.classList.add('is-invalid')
            time.classList.remove('is-valid')
          }else {
            time.classList.add('is-valid')
            time.classList.remove('is-invalid')
          }
        }
      },

      saveWoundCourse() {
        this.loading = true
        if (this.currentStep === 5) {
          this.loading = false
          this.currentStep += 1
          return
        }

        // Set data
        this.form.Wunderhebung = this.formatDateY(this.wunderhebung)
        this.form.Enstehungszeitpunkt = this.formatDateY(this.enstehungszeitpunkt)
        this.form.Heilungszeitpunkt = this.formatDateY(this.heilungszeitpunkt)
        this.form.Kausaltherapie_Seit = this.formatDateY(this.kausaltherapie_Seit)

        var userDate= new Date(this.datum + ' ' + this.uhrzeit)
        this.form.AenderungAm =  this.serverDateFormat(userDate)
        this.form.AenderungVon = this.loginUser.username
        this.form.GastId = this.roomID

        this.form.Wunderhebung =  this.form.Wunderhebung ? this.serverDateFormat(new Date(this.form.Wunderhebung+ ' ' + this.uhrzeit)) : ''
        this.form.Enstehungszeitpunkt =  this.form.Enstehungszeitpunkt ? this.serverDateFormat(new Date(this.form.Enstehungszeitpunkt+ ' ' + this.uhrzeit)) : ''
        this.form.Heilungszeitpunkt =  this.form.Heilungszeitpunkt ? this.serverDateFormat(new Date(this.form.Heilungszeitpunkt+ ' ' + this.uhrzeit)) : ''
        this.form.Kausaltherapie_Seit =  this.form.Kausaltherapie_Seit ? this.serverDateFormat(new Date(this.form.Kausaltherapie_Seit+ ' ' + this.uhrzeit)) : ''

        this.$refs.form.validate().then(success => {
          if (!success) {
            this.loading = false
            return
          }

          this.$http.post('Wunderhebung', this.form)
            .then(res => {
              if(res.data) {
                this.$notify.success({message: 'Wunderhebung erstellen erfolgreich', position: 'top right', closeButton: false, timeOut: 5000})
                this.save()
              }else {
                this.$notify.error({message: 'Gescheitert Wunderhebung erstellen!!', position: 'top right', closeButton: false, timeOut: 5000})
              }
            })
            .finally(() => {
              this.loading = false
            })
        });
      },

      validate(step) {
        let ort = document.getElementById('ort')
        if (step === 1) {
          if(this.$refs.ort.innerValue) {
            ort.classList.add('is-valid')
            ort.classList.remove('is-invalid')

            this.validatedSteps[1] = true
            this.currentStep += 1
          }else {
            ort.classList.add('is-invalid')
            ort.classList.remove('is-valid')
          }
        }
        else if (step === 2)
        {
          this.validatedSteps[2] = true
          this.currentStep += 1
        }
        else if (step === 3)
        {
          this.validatedSteps[3] = true
          this.currentStep += 1
        }
        else if (step === 4)
        {
          this.validatedSteps[4] = true
          this.currentStep += 1
        }
        else if (step === 5)
        {
          this.validatedSteps[5] = true
          this.currentStep += 1
        }
      }
    }
  }
</script>
